import { Crown, ExternalLink } from "lucide-react";
import { useSubMenu } from "../../SubMenuContext";
import { EmpreenderApps } from "../../lib/AppsArray";
import { useUser } from "../../UserContext";
import { twMerge } from "tailwind-merge";

interface ProfileProps {
    nome: string;
    imagem_perfil: string;
    chave_empreender: string;
}

const ProfileImage = ({ imagem_perfil, nome }: ProfileProps) => {

    return (
        <div className="size-20 overflow-hidden flex-shrink-0 absolute top-[20px] left-[calc(1rem-5px)]">
            <div className="size-full">
                {imagem_perfil ? (
                    <img src={imagem_perfil} alt="Imagem de perfil" className="size-full object-cover rounded-3xl aspect-square flex-shrink-0 border-[5px] border-white" />

                ) : (
                    <div className="size-full !select-none !pointer-events-none object-cover rounded-3xl aspect-square flex-shrink-0 border-[5px] border-white bg-gray-900 text-white flex items-center justify-center font-bold">
                        {nome?.charAt(0).toUpperCase()}
                    </div>
                )}
            </div>
        </div>
    )

};

const CrownInside = () => {
    return (
        <>
            <div className="flex-shrink-0">
                <Crown />
            </div>

            <span className="whitespace-nowrap text-xs font-medium leading-4 tracking-normal text-yellow-900 font-sans">Upgrade</span>
        </>
    )
};

const BadgePlano = () => {
    const { app } = useSubMenu();
    const { chave_empreender, current_store } = useUser()?.user || {};
    const { hideApps } = useUser();
    const { nome_plano } = current_store || {};

    const matchApp = EmpreenderApps.find((a) =>
        a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase())
    );

    if (!nome_plano || nome_plano === '') {
        return <></>
    }

    const classe = `w-[66px] h-[20px] absolute right-[18px] top-[18px] [&_svg]:stroke-[2.9] box-content px-[10px] py-[2px] border flex-shrink-0 border-yellow-500 bg-[#FFECB3] text-yellow-900 flex flex-row gap-1 items-center justify-center text-xs font-medium leading-4 rounded-lg [&_svg]:!size-3`;

    return (
        <>
            {
                hideApps ? <>
                    <div className={twMerge(classe)}>
                        <CrownInside />
                    </div>
                </>
                    : <a href={`https://app.empreender.plus/planos?app=${matchApp?.eplus}&c=${chave_empreender}`} target="_blank" className={twMerge(classe)}>
                        <CrownInside />
                    </a>
            }
        </>
    )
};

const Profile = () => {
    const { chave_empreender, imagem_perfil, name: nome, current_store } = useUser()?.user || {};

    return (
        <div className="w-full flex flex-col gap-12">
            <div className="rounded-t-xl bg-[#8346F9] w-full h-[60px] relative">
                <BadgePlano />
                <ProfileImage imagem_perfil={imagem_perfil as string} nome={nome as string} chave_empreender={chave_empreender as string} />
            </div>

            <div className="px-4">
                <p className="overflow-hidden whitespace-nowrap text-ellipsis text-gray-900 font-sans text-2xl font-bold leading-8 tracking-normal">{nome}</p>
                {
                    current_store?.link_loja && (
                        <a
                            href={current_store.link_loja}
                            target="_blank"
                            className="overflow-hidden whitespace-nowrap text-ellipsis text-gray-500 font-sans text-sm font-normal leading-5 tracking-normal flex flex-row flex-nowrap items-center gap-[6px] [&_svg]:size-[14px] [&_svg]:stroke-[2.6]">
                            {current_store.link_loja.replace(/^https?:\/\//, "")}
                            <ExternalLink size={14} />
                        </a>
                    )}
            </div>
        </div>
    )
};

export default Profile;